import BetragsrechnerMixin from "../Mixins/BetragsrechnerMixin";
import BildungsKostenrechnerMixin from "../Mixins/BildungsKostenrechnerMixin";
import TagespauschaleMixin from "../Mixins/TagespauschaleMixin";

// @vue/component
export default {
  name: "BildungsKostenrechner",
  mixins: [
    BetragsrechnerMixin,
    BildungsKostenrechnerMixin,
    TagespauschaleMixin,
  ],
  data() {
    return {
      labelAnzahlTage: "_LBL_BILDUNGS_KOSTENRECHNER_ANZAHL_TAGE_",
      labelAnzahlPersonen: "_LBL_BILDUNGS_KOSTENRECHNER_ANZAHL_PERSONEN_",
    };
  },
  created() {
    this.changeModelWithTagespauschale();
  },
};
